import { create } from "zustand";

interface WindowStore {
  width: number;
  setWidth: (w: number) => void;
}

export const useWindowStore = create<WindowStore>((set) => ({
  width: window.innerWidth,
  setWidth: (w) => set({ width: w }),
}));
